const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "MethodName",
    label: "接口类型",
    columnwidth: 120,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 50,
  },
  {
    prop: "U8RdCode",
    label: "U8单据号",
    columnwidth: 140,
  },
  {
    prop: "U8CusName",
    label: "U8客户名称",
    columnwidth: 200,
  },
  {
    prop: "CusName",
    label: "上报系统客户名称",
    columnwidth: 214,
  },
  {
    prop: "AccId",
    label: "U8套账号",
    columnwidth: 80,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 100,
  },
  {
    prop: "SynTime",
    label: "运行时间",
    columnwidth: 100,
  },
  {
    prop: "SynMessage",
    label: "信息",
    columnwidth: 80,
  },
  {
    prop: "SkipReason",
    label: "跳过原因",
    columnwidth: 150,
  },
  {
    prop: "SkipperName",
    label: "跳过人",
    columnwidth: 100,
  },
  {
    prop: "SkipTime",
    label: "跳过时间",
    columnwidth: 100,
  }
]
export default headerData;
